module.exports = __webpack_public_path__ + "static/animated2.066da6bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/animated2.svg
// module id = 483
// module chunks = 35783957827783